import { render, staticRenderFns } from "./FormPlusMinus.vue?vue&type=template&id=6f647aa6&scoped=true&"
import script from "./FormPlusMinus.vue?vue&type=script&lang=js&"
export * from "./FormPlusMinus.vue?vue&type=script&lang=js&"
import style0 from "./FormPlusMinus.vue?vue&type=style&index=0&id=6f647aa6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f647aa6",
  null
  
)

export default component.exports